(function () {
  'use strict';

  function cleanLeadingText(element) {
    while (
      element.firstChild &&
      element.firstChild.nodeType === 3 &&
      !element.firstChild.textContent.trim()
    ) {
      element.removeChild(element.firstChild);
    }

    if (element.firstChild && element.firstChild.nodeType === 3) {
      element.firstChild.textContent = element.firstChild.textContent.replace(/^\s*:\s*/, '');
      if (!element.firstChild.textContent.trim()) {
        element.removeChild(element.firstChild);
      }
    }
  }

  function normaliseText(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripHtml(value) {
    var temporaryElement = document.createElement('div');
    temporaryElement.innerHTML = value || '';
    return normaliseText(
      temporaryElement.textContent || temporaryElement.innerText || ''
    );
  }

  function isHeadingElement(element) {
    return Boolean(element && /^H[1-6]$/.test(element.tagName));
  }

  function headingLevel(element) {
    if (!isHeadingElement(element)) return 7;
    return parseInt(element.tagName.substring(1), 10) || 7;
  }

  function headingText(element) {
    if (!isHeadingElement(element)) return '';
    return normaliseText(element.textContent).toLowerCase();
  }

  function isQuickDetailsHeading(element) {
    var text = headingText(element);
    return text === 'quick details' || text === 'quick detail' || text === 'specifications';
  }

  function isProductOverviewHeading(element) {
    var text = headingText(element);
    return (
      text === 'product overview' ||
      text === 'overview' ||
      text === 'product information'
    );
  }

  function isCustomizationHeading(element) {
    var text = headingText(element);
    if (!text) return false;

    return (
      /customi[sz]ation/.test(text) ||
      text === 'compatibility' ||
      text === 'custom options' ||
      text === 'custom options & compatibility' ||
      text === 'custom options and compatibility' ||
      text === 'customization & installation' ||
      text === 'customisation & installation'
    );
  }

  function hasMeaningfulContent(element) {
    if (!element) return false;

    if (normaliseText(element.textContent)) return true;

    return Boolean(
      element.querySelector(
        'img, picture, video, iframe, table, ul, ol, svg, blockquote, details'
      )
    );
  }

  function removeLeadingEmptyNodes(element) {
    if (!element) return;

    while (element.firstChild) {
      var node = element.firstChild;

      if (node.nodeType === 3) {
        if (!normaliseText(node.textContent)) {
          node.remove();
          continue;
        }
        break;
      }

      if (node.nodeType !== 1) break;

      var hasText = normaliseText(node.textContent);
      var hasMedia = node.querySelector(
        'img, picture, video, iframe, table, ul, ol, svg, blockquote, details'
      );

      if (!hasText && !hasMedia) {
        node.remove();
        continue;
      }

      break;
    }
  }

  function removeLeadingOverviewHeading(element) {
    removeLeadingEmptyNodes(element);

    var firstElement = element.firstElementChild;
    if (firstElement && isProductOverviewHeading(firstElement)) {
      firstElement.remove();
      removeLeadingEmptyNodes(element);
    }
  }

  function stripQuickDetailHtml(value) {
    return stripHtml(value);
  }

  function isWideQuickDetail(label, value) {
    var normalisedLabel = (label || '').toLowerCase();
    var plainValue = stripQuickDetailHtml(value);

    var alwaysWide =
      /overall size|size options?|dimensions?|colour temperature|color temperature|recommended spaces?|suitable location|compliance|what['’]?s included|voltage|led replacement|natural variation|installation notes?/i;

    return alwaysWide.test(normalisedLabel) || plainValue.length > 58;
  }

  function balanceMobileQuickDetails(grid) {
    var rows = Array.prototype.slice.call(grid.children);
    var pendingHalfWidthRow = null;

    rows.forEach(function (row) {
      row.classList.remove('is-mobile-wide');

      if (row.classList.contains('is-wide')) {
        if (pendingHalfWidthRow) {
          pendingHalfWidthRow.classList.add('is-mobile-wide');
          pendingHalfWidthRow = null;
        }
        return;
      }

      if (pendingHalfWidthRow) {
        pendingHalfWidthRow = null;
      } else {
        pendingHalfWidthRow = row;
      }
    });

    if (pendingHalfWidthRow) {
      pendingHalfWidthRow.classList.add('is-mobile-wide');
    }
  }

  function enhanceQuickDetails(scope) {
    if (!scope || !scope.classList.contains('has-quick-details-style')) return;

    var containers = scope.querySelectorAll(
      '.lubrel-quick-details:not([data-lbr-quick-details-ready])'
    );

    containers.forEach(function (container) {
      var existingGrid = container.querySelector('.lbr-quick-details-grid');
      if (existingGrid) {
        balanceMobileQuickDetails(existingGrid);
        container.setAttribute('data-lbr-quick-details-ready', 'true');
        container.classList.add('is-enhanced');
        return;
      }

      var source = container.querySelector(':scope > p');
      if (!source || !source.querySelector('strong')) return;

      var lines = [];
      var currentNodes = [];

      function pushLine() {
        if (!currentNodes.length) return;

        var holder = document.createElement('div');
        currentNodes.forEach(function (node) {
          holder.appendChild(node);
        });
        currentNodes = [];

        if (!normaliseText(holder.textContent)) return;

        var strong = holder.querySelector('strong');
        if (!strong) return;

        var label = normaliseText(strong.textContent).replace(/\s*:\s*$/, '');
        strong.remove();
        cleanLeadingText(holder);

        var value = holder.innerHTML.trim();
        if (!label || !stripHtml(value)) return;

        lines.push({ label: label, value: value });
      }

      Array.prototype.slice.call(source.childNodes).forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'BR') {
          pushLine();
        } else {
          currentNodes.push(node.cloneNode(true));
        }
      });
      pushLine();

      if (!lines.length) return;

      var grid = document.createElement('div');
      grid.className = 'lbr-quick-details-grid';
      grid.setAttribute('role', 'list');

      lines.forEach(function (line) {
        var row = document.createElement('div');
        row.className =
          'lbr-quick-detail-row' +
          (isWideQuickDetail(line.label, line.value) ? ' is-wide' : '');
        row.setAttribute('role', 'listitem');

        var label = document.createElement('div');
        label.className = 'lbr-quick-detail-label';
        label.textContent = line.label;

        var value = document.createElement('div');
        value.className = 'lbr-quick-detail-value';
        value.innerHTML = line.value;

        row.appendChild(label);
        row.appendChild(value);
        grid.appendChild(row);
      });

      balanceMobileQuickDetails(grid);
      source.replaceWith(grid);
      container.classList.add('is-enhanced');
      container.setAttribute('data-lbr-quick-details-ready', 'true');
    });
  }

  function findSectionByHeading(source, matcher) {
    if (!source) return null;

    var headings = source.querySelectorAll('h1, h2, h3, h4, h5, h6');
    var matchedHeading = null;

    Array.prototype.some.call(headings, function (heading) {
      if (matcher(heading)) {
        matchedHeading = heading;
        return true;
      }
      return false;
    });

    if (!matchedHeading) return null;

    var section = document.createElement('div');
    var current = matchedHeading.nextSibling;
    var currentHeadingLevel = headingLevel(matchedHeading);

    while (current) {
      var next = current.nextSibling;

      if (
        current.nodeType === 1 &&
        isHeadingElement(current) &&
        headingLevel(current) <= currentHeadingLevel
      ) {
        break;
      }

      section.appendChild(current);
      current = next;
    }

    matchedHeading.remove();
    return section;
  }

  function categoryForCustomization(label, value) {
    var text = normaliseText((label || '') + ' ' + (value || '')).toLowerCase();

    if (
      /(cord|cable|wire|suspension)/.test(text) &&
      /(length|adjust|extend|shorten|custom)/.test(text)
    ) {
      return 'Cord Length';
    }

    if (/dimmable|dimming|dimmer/.test(text)) {
      return 'Dimming';
    }

    if (/colour temperature|color temperature|\bcct\b/.test(text)) {
      return 'Colour Temperature';
    }

    if (/sloped ceiling|sloping ceiling|inclined ceiling|raked ceiling/.test(text)) {
      return 'Sloped Ceiling';
    }

    if (
      /(ceiling rose|canopy|backplate|cord colour|cord color|cable colour|cable color|finish|hardware)/.test(text) &&
      /(custom|option|available|request|choose|choice)/.test(text)
    ) {
      return 'Finish / Hardware';
    }

    if (
      /(custom size|custom sizing|custom dimension|custom dimensions|made to measure)/.test(text) ||
      (/(size|dimension)/.test(text) && /custom/.test(text))
    ) {
      return 'Custom Size';
    }

    if (/customization|customisation|custom options?|custom requests?|contact lubrel support/.test(text)) {
      return 'Customization';
    }

    if (/hardwired|installation|install|electrician/.test(text)) {
      return 'Installation';
    }

    if (/voltage|110\s*[-–]?\s*120v|220\s*[-–]?\s*240v/.test(text)) {
      return 'Voltage';
    }

    return '';
  }

  function splitBlockIntoStrongLines(block) {
    var lines = [];
    var currentNodes = [];

    function pushLine() {
      if (!currentNodes.length) return;

      var holder = document.createElement('div');
      currentNodes.forEach(function (node) {
        holder.appendChild(node);
      });
      currentNodes = [];

      var strong = holder.querySelector('strong');
      if (!strong) return;

      var label = normaliseText(strong.textContent).replace(/\s*:\s*$/, '');
      strong.remove();
      cleanLeadingText(holder);

      var value = normaliseText(holder.textContent);
      if (label && value) {
        lines.push({ label: label, value: value });
      }
    }

    Array.prototype.slice.call(block.childNodes).forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'BR') {
        pushLine();
      } else {
        currentNodes.push(node.cloneNode(true));
      }
    });
    pushLine();

    return lines;
  }

  function extractStructuredCustomization(section) {
    var items = [];
    var seenCategories = {};

    section.querySelectorAll('p, li').forEach(function (block) {
      splitBlockIntoStrongLines(block).forEach(function (pair) {
        var category = categoryForCustomization(pair.label, pair.value);
        if (!category || seenCategories[category]) return;

        seenCategories[category] = true;
        items.push({
          label: category,
          value: pair.value,
          source: normaliseText(pair.label + ' ' + pair.value)
        });
      });
    });

    return { items: items, seenCategories: seenCategories };
  }

  function sectionSentences(section) {
    var clone = section.cloneNode(true);

    clone.querySelectorAll('br').forEach(function (br) {
      br.replaceWith(document.createTextNode('. '));
    });

    clone.querySelectorAll('p, li, div').forEach(function (block) {
      if (block.nextSibling) {
        block.appendChild(document.createTextNode('. '));
      }
    });

    var text = normaliseText(clone.textContent)
      .replace(/\s*\.\s*\./g, '. ')
      .replace(/\s*;\s*/g, '; ');

    if (!text) return [];

    /* Protect decimal points (for example 59.06\", 11.81\", 32.68\")
       so they are not mistaken for sentence-ending periods. */
    var decimalMarker = '\uE000';
    var protectedText = text.replace(/(\d)\.(\d)/g, '$1' + decimalMarker + '$2');

    var matches = protectedText.match(/[^.!?]+[.!?]?/g) || [];
    return matches
      .map(function (sentence) {
        return normaliseText(sentence.replace(new RegExp(decimalMarker, 'g'), '.'));
      })
      .filter(Boolean);
  }

  function extractSentenceCustomization(section, existing) {
    var items = [];
    var seenCategories = existing || {};
    var seenText = {};
    var genericCount = 0;

    sectionSentences(section).forEach(function (sentence) {
      var cleanSentence = normaliseText(sentence);
      var lower = cleanSentence.toLowerCase();

      if (!cleanSentence || seenText[lower]) return;
      seenText[lower] = true;

      var category = categoryForCustomization('', cleanSentence);
      if (category) {
        if (!seenCategories[category]) {
          seenCategories[category] = true;
          items.push({
            label: category,
            value: cleanSentence.replace(new RegExp('^' + category.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*:\\s*', 'i'), ''),
            source: cleanSentence
          });
        }
        return;
      }

      var relevant =
        /custom|available on request|on request|contact|adjust|compatible|compatibility|option|installation|install|sloped|dimm|colour temperature|color temperature|cord|cable|ceiling rose|canopy|backplate/i.test(
          cleanSentence
        );

      if (relevant && genericCount < 2 && cleanSentence.length <= 240) {
        genericCount += 1;
        items.push({ label: '', value: cleanSentence, source: cleanSentence });
      }
    });

    return items;
  }

  function dedupeCustomizationItems(items) {
    var output = [];
    var seenLabels = {};
    var seenValues = {};

    items.forEach(function (item) {
      var value = normaliseText(item.value);
      var label = normaliseText(item.label);
      var valueKey = value.toLowerCase();
      var labelKey = label.toLowerCase();

      if (!value || seenValues[valueKey]) return;
      if (label && seenLabels[labelKey]) return;

      seenValues[valueKey] = true;
      if (label) seenLabels[labelKey] = true;
      output.push({ label: label, value: value });
    });

    return output.slice(0, 5);
  }

  function buildCustomizationSummary(section) {
    if (!section || !hasMeaningfulContent(section)) return null;

    var structured = extractStructuredCustomization(section);
    var sentenceItems = extractSentenceCustomization(
      section,
      structured.seenCategories
    );
    var items = dedupeCustomizationItems(
      structured.items.concat(sentenceItems)
    );

    var wrapper = document.createElement('section');
    wrapper.className = 'lbr-customization-installation';
    wrapper.setAttribute('data-lbr-customization-installation', '');

    var heading = document.createElement('h4');
    heading.className = 'lbr-customization-heading';
    heading.textContent = 'Customization & Installation';
    wrapper.appendChild(heading);

    if (items.length) {
      var list = document.createElement('ul');
      list.className = 'lbr-customization-list';

      items.forEach(function (item) {
        var listItem = document.createElement('li');
        listItem.className = 'lbr-customization-item';

        if (item.label) {
          var label = document.createElement('span');
          label.className = 'lbr-customization-label';
          label.textContent = item.label;
          listItem.appendChild(label);
        } else {
          listItem.classList.add('is-general');
        }

        var value = document.createElement('span');
        value.className = 'lbr-customization-value';
        value.textContent = item.value;
        listItem.appendChild(value);

        list.appendChild(listItem);
      });

      wrapper.appendChild(list);

      var hasCustomizationContact = items.some(function (item) {
        return (
          normaliseText(item.label).toLowerCase() === 'customization' ||
          /contact lubrel support|custom requests?/i.test(normaliseText(item.value))
        );
      });

      if (!hasCustomizationContact) {
        var note = document.createElement('p');
        note.className = 'lbr-customization-note';
        note.textContent =
          'For custom requests, please contact Lubrel Support before ordering.';
        wrapper.appendChild(note);
      }
    } else {
      var fallback = document.createElement('p');
      fallback.className = 'lbr-customization-fallback';
      fallback.textContent =
        'Customization: Contact Lubrel Support to discuss available custom options.';
      wrapper.appendChild(fallback);
    }

    return wrapper;
  }

  function setWrapperActive(wrapper, active) {
    if (!wrapper) return;

    wrapper.classList.toggle('t4s-active', active);

    var content = wrapper.querySelector(':scope > [data-t4s-tab-content]');
    if (content) {
      content.classList.toggle('t4s-active', active);
    }

    var title = wrapper.querySelector(':scope > [data-t4s-tab-item]');
    if (title) {
      title.setAttribute('aria-expanded', active ? 'true' : 'false');
    }
  }

  function setNavigationActive(item, active) {
    if (!item) return;

    var link = item.querySelector('[data-t4s-tab-item]');
    if (link) {
      link.classList.toggle('t4s-active', active);
      link.setAttribute('aria-expanded', active ? 'true' : 'false');
    }
  }

  function getSpecificationsElements(root) {
    return {
      wrapper: root.querySelector(
        '[data-lbr-specifications-wrapper], [data-lbr-quick-details-wrapper]'
      ),
      panel: root.querySelector(
        '[data-lbr-specifications-panel], [data-lbr-quick-details-panel]'
      ),
      target: root.querySelector(
        '[data-lbr-specifications-target], [data-lbr-quick-details-target]'
      ),
      navItem: root.querySelector(
        '[data-lbr-specifications-nav-item], [data-lbr-quick-details-nav-item]'
      )
    };
  }

  function getOverviewElements(root) {
    return {
      wrapper: root.querySelector(
        '[data-lbr-product-overview-wrapper], [data-lbr-product-information-wrapper]'
      ),
      panel: root.querySelector(
        '[data-lbr-product-overview-panel], [data-lbr-product-information-wrapper] [data-lbr-preview-panel]'
      ),
      navItem: root.querySelector(
        '[data-lbr-product-overview-nav-item], [data-lbr-product-information-nav-item]'
      )
    };
  }

  function prepareOverviewMobileMedia(source, mediaPanel) {
    if (!source || !mediaPanel) return;

    source.querySelectorAll('[data-lbr-overview-mobile-media]').forEach(function (item) {
      item.remove();
    });

    var mediaItems = Array.prototype.slice.call(
      mediaPanel.querySelectorAll('.lbr-overview-media-item')
    ).slice(0, 2);
    if (!mediaItems.length) return;

    function cloneMediaItem(item, index) {
      var mobileItem = item.cloneNode(true);
      mobileItem.classList.add('lbr-overview-mobile-media');
      mobileItem.classList.add(index === 0 ? 'is-primary' : 'is-secondary');
      mobileItem.setAttribute('data-lbr-overview-mobile-media', '');
      mobileItem.removeAttribute('data-lbr-overview-metafield-item');
      mobileItem.removeAttribute('data-lbr-overview-fallback-item');

      mobileItem.querySelectorAll('[id]').forEach(function (element) {
        element.removeAttribute('id');
      });

      mobileItem.querySelectorAll('img').forEach(function (image) {
        image.setAttribute('loading', 'lazy');
        image.setAttribute('decoding', 'async');
      });

      return mobileItem;
    }

    var introParagraphs = Array.prototype.slice.call(
      source.querySelectorAll(':scope > .lbr-overview-intro')
    );
    var keyHeading = source.querySelector('.lbr-overview-key-features-heading');
    var firstMobileItem = cloneMediaItem(mediaItems[0], 0);

    if (introParagraphs.length) {
      introParagraphs[introParagraphs.length - 1].insertAdjacentElement('afterend', firstMobileItem);
    } else if (keyHeading) {
      keyHeading.insertAdjacentElement('beforebegin', firstMobileItem);
    } else {
      source.insertBefore(firstMobileItem, source.firstChild);
    }

    if (mediaItems.length < 2) return;

    var secondMobileItem = cloneMediaItem(mediaItems[1], 1);
    var designHeading = null;

    Array.prototype.some.call(
      source.querySelectorAll('h1, h2, h3, h4, h5, h6'),
      function (heading) {
        var text = normaliseText(heading.textContent).toLowerCase();
        if (
          text === 'design & materials' ||
          text === 'design and materials' ||
          text === 'materials & design' ||
          text === 'materials and design'
        ) {
          designHeading = heading;
          return true;
        }
        return false;
      }
    );

    if (!designHeading) {
      source.appendChild(secondMobileItem);
      return;
    }

    var designLevel = headingLevel(designHeading);
    var cursor = designHeading.nextElementSibling;
    var insertBefore = null;

    while (cursor) {
      if (isHeadingElement(cursor) && headingLevel(cursor) <= designLevel) {
        insertBefore = cursor;
        break;
      }
      cursor = cursor.nextElementSibling;
    }

    if (insertBefore) {
      source.insertBefore(secondMobileItem, insertBefore);
    } else {
      source.appendChild(secondMobileItem);
    }
  }

  function enhanceOverviewPresentation(root, source) {
    if (!root || !source || source.hasAttribute('data-lbr-overview-presentation-ready')) return;

    source.setAttribute('data-lbr-overview-presentation-ready', 'true');

    var layout = source.closest('[data-lbr-overview-layout]');
    var mediaPanel = layout && layout.querySelector('[data-lbr-overview-media]');

    /* Product Overview image priority:
       1) Product metafield images chosen in Shopify admin.
       2) Existing images inside the product description.
       3) Existing product-media fallbacks rendered by Liquid.
       This keeps older products working without rewriting descriptions. */
    if (mediaPanel) {
      var descriptionImages = Array.prototype.slice.call(source.querySelectorAll('img')).filter(function (img) {
        if (!img) return false;
        if (img.closest('.lubrel-quick-details')) return false;
        return true;
      }).slice(0, 2);

      function hideSourceDescriptionImage(descriptionImage) {
        var mediaOnlyContainer = descriptionImage.closest('figure, p, div');
        if (
          mediaOnlyContainer &&
          mediaOnlyContainer !== source &&
          !normaliseText(mediaOnlyContainer.textContent) &&
          mediaOnlyContainer.querySelectorAll('img').length === 1
        ) {
          mediaOnlyContainer.classList.add('lbr-overview-source-media');
        } else {
          descriptionImage.classList.add('lbr-overview-source-media');
        }
      }

      var usesMetafieldMedia =
        mediaPanel.getAttribute('data-lbr-overview-media-source') === 'metafield';

      if (usesMetafieldMedia) {
        /* Metafield images are explicitly curated by the merchant, so they take
           priority. Hide the first two legacy description images to prevent
           duplicate visuals while leaving any other inline content untouched. */
        descriptionImages.forEach(hideSourceDescriptionImage);
        mediaPanel.hidden = !mediaPanel.children.length;
        if (layout) layout.classList.toggle('has-media', mediaPanel.children.length > 0);
      } else if (descriptionImages.length) {
        var fallbackItems = Array.prototype.slice.call(
          mediaPanel.querySelectorAll('[data-lbr-overview-fallback-item]')
        );
        var descriptionItems = [];

        descriptionImages.forEach(function (descriptionImage) {
          var clonedImage = descriptionImage.cloneNode(true);
          clonedImage.removeAttribute('id');
          clonedImage.classList.add('lbr-overview-description-image');
          clonedImage.setAttribute('loading', 'lazy');
          clonedImage.setAttribute('decoding', 'async');

          var item = document.createElement('div');
          item.className = 'lbr-overview-media-item is-description-media';

          var width = parseFloat(descriptionImage.getAttribute('width')) || descriptionImage.naturalWidth || 0;
          var height = parseFloat(descriptionImage.getAttribute('height')) || descriptionImage.naturalHeight || 0;
          var ratio = width && height ? width / height : 0;
          if (ratio >= 1.15) {
            item.classList.add('is-landscape');
          } else {
            item.classList.add('is-contain');
          }

          item.appendChild(clonedImage);
          descriptionItems.push(item);
          hideSourceDescriptionImage(descriptionImage);
        });

        /* Description-derived images retain the existing fallback behavior.
           Product gallery images only fill unused slots up to two total. */
        mediaPanel.innerHTML = '';
        descriptionItems.forEach(function (item) {
          mediaPanel.appendChild(item);
        });
        fallbackItems.slice(0, Math.max(0, 2 - descriptionItems.length)).forEach(function (item) {
          mediaPanel.appendChild(item);
        });

        mediaPanel.hidden = false;
        if (layout) layout.classList.add('has-media');
      }
    }

    var children = Array.prototype.slice.call(source.children);
    var reachedHeading = false;

    children.forEach(function (child) {
      if (isHeadingElement(child)) reachedHeading = true;
      if (!reachedHeading && child.tagName === 'P') {
        child.classList.add('lbr-overview-intro');
      }
    });

    source.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (heading) {
      var text = normaliseText(heading.textContent).toLowerCase();

      if (text === 'key features' || text === 'key feature') {
        heading.classList.add('lbr-overview-key-features-heading');
        var list = heading.nextElementSibling;
        if (list && (list.tagName === 'UL' || list.tagName === 'OL')) {
          list.classList.add('lbr-overview-key-features-list');
        }
      }

      if (
        text === 'design & materials' ||
        text === 'design and materials' ||
        text === 'materials & design' ||
        text === 'materials and design'
      ) {
        heading.classList.add('lbr-overview-design-heading');
      }
    });

    if (mediaPanel && !mediaPanel.hidden) {
      prepareOverviewMobileMedia(source, mediaPanel);
    }
  }

  function splitProductDescription(root) {
    var source = root.querySelector(
      '[data-lbr-product-description-source]:not([data-lbr-description-split-ready])'
    );
    if (!source) return;

    source.setAttribute('data-lbr-description-split-ready', 'true');

    var specifications = getSpecificationsElements(root);
    var overview = getOverviewElements(root);

    var quickDetails = source.querySelector('.lubrel-quick-details');
    var hasQuickDetails = Boolean(
      quickDetails &&
      quickDetails.querySelector('strong') &&
      normaliseText(quickDetails.textContent)
    );

    if (hasQuickDetails && specifications.target) {
      var quickHeading = quickDetails.previousElementSibling;
      if (isQuickDetailsHeading(quickHeading)) {
        quickHeading.remove();
      }

      specifications.target.appendChild(quickDetails);
    } else if (quickDetails && !hasMeaningfulContent(quickDetails)) {
      var emptyQuickHeading = quickDetails.previousElementSibling;
      if (isQuickDetailsHeading(emptyQuickHeading)) {
        emptyQuickHeading.remove();
      }
      quickDetails.remove();
    }

    var customizationSection = findSectionByHeading(source, isCustomizationHeading);
    var customizationSummary = buildCustomizationSummary(customizationSection);

    if (customizationSummary && specifications.target) {
      specifications.target.appendChild(customizationSummary);
    }

    if (specifications.panel) {
      enhanceQuickDetails(specifications.panel);
    }

    var hasSpecifications = Boolean(
      specifications.target && hasMeaningfulContent(specifications.target)
    );

    if (specifications.wrapper) {
      specifications.wrapper.hidden = !hasSpecifications;
    }
    if (specifications.navItem) {
      specifications.navItem.hidden = !hasSpecifications;
    }

    removeLeadingEmptyNodes(source);
    removeLeadingOverviewHeading(source);
    enhanceOverviewPresentation(root, source);

    source.querySelectorAll('img').forEach(function (image) {
      if (!image.hasAttribute('loading')) image.setAttribute('loading', 'lazy');
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
    });

    var hasOverview = hasMeaningfulContent(source);

    if (overview.wrapper) {
      overview.wrapper.hidden = !hasOverview;
    }
    if (overview.navItem) {
      overview.navItem.hidden = !hasOverview;
    }

    var specsWasActive = Boolean(
      specifications.wrapper && specifications.wrapper.classList.contains('t4s-active')
    );
    var overviewWasActive = Boolean(
      overview.wrapper && overview.wrapper.classList.contains('t4s-active')
    );

    if (!hasOverview && hasSpecifications && overviewWasActive) {
      setWrapperActive(overview.wrapper, false);
      setWrapperActive(specifications.wrapper, true);
      setNavigationActive(overview.navItem, false);
      setNavigationActive(specifications.navItem, true);
    }

    if (!hasSpecifications && hasOverview && specsWasActive) {
      setWrapperActive(specifications.wrapper, false);
      setWrapperActive(overview.wrapper, true);
      setNavigationActive(specifications.navItem, false);
      setNavigationActive(overview.navItem, true);
    }
  }

  function updateAriaExpanded(root) {
    root.querySelectorAll('[data-t4s-tab-item]').forEach(function (tabButton) {
      var wrapper = tabButton.closest('[data-t4s-tab-wrapper]');
      if (!wrapper) return;

      var isOpen =
        !wrapper.hidden && wrapper.classList.contains('t4s-active');
      tabButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function getStickyHeaderOffset() {
    var header = document.querySelector('.t4s-section-header');
    if (!header) return 0;

    var height = Math.ceil(header.getBoundingClientRect().height || 0);
    return height > 0 ? height : 0;
  }

  function scrollToPreviewTop(panel) {
    var wrapper = panel.closest('[data-t4s-tab-wrapper]');
    if (!wrapper) return;

    var wrapperTop =
      window.pageYOffset + wrapper.getBoundingClientRect().top;
    var targetTop = Math.max(
      0,
      wrapperTop - getStickyHeaderOffset() - 8
    );

    var rootElement = document.documentElement;
    var previousScrollBehavior = rootElement.style.scrollBehavior;

    rootElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, targetTop);

    window.requestAnimationFrame(function () {
      rootElement.style.scrollBehavior = previousScrollBehavior;
    });
  }

  function updateSpecificationsPreviewMinimum(panel) {
    if (!panel || !panel.hasAttribute('data-lbr-specifications-panel')) return;

    var clip = panel.querySelector(':scope > [data-lbr-details-clip]');
    var gallery = clip && clip.querySelector('[data-lbr-dimensions-gallery]');

    if (!clip || !gallery) {
      panel.style.removeProperty('--lbr-specifications-min-height');
      return;
    }

    /* Closed accordion panels have no measurable layout. The same function is
       called again after the panel opens, on resize, and after gallery swaps. */
    if (!clip.getClientRects().length || !gallery.getClientRects().length) return;

    var clipRect = clip.getBoundingClientRect();
    var minimumBottom = gallery.getBoundingClientRect().bottom;
    var rows = Array.prototype.slice.call(
      clip.querySelectorAll('.lbr-quick-details-grid > .lbr-quick-detail-row')
    );

    /* Keep the gallery plus the first visible specification row intact. This
       prevents Show more from cutting a dimension image or a specification row
       in half while preserving the merchant-configured preview height. */
    if (rows.length) {
      var firstTop = rows[0].offsetTop;
      rows.forEach(function (row) {
        if (Math.abs(row.offsetTop - firstTop) <= 4) {
          minimumBottom = Math.max(minimumBottom, row.getBoundingClientRect().bottom);
        }
      });
    }

    var minimumHeight = Math.ceil(minimumBottom - clipRect.top + 16);
    if (minimumHeight > 0) {
      panel.style.setProperty('--lbr-specifications-min-height', minimumHeight + 'px');
    }
  }

  function initialiseDimensionGalleries(root) {
    root.querySelectorAll('[data-lbr-dimensions-gallery]:not([data-lbr-dimensions-ready])').forEach(function (gallery) {
      gallery.setAttribute('data-lbr-dimensions-ready', 'true');

      var mainImage = gallery.querySelector('.lbr-dimensions-main-image');
      var thumbnails = Array.prototype.slice.call(
        gallery.querySelectorAll('[data-lbr-dimension-thumb]')
      );
      if (!mainImage || !thumbnails.length) return;

      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function (event) {
          event.preventDefault();

          if (thumbnail.classList.contains('is-active')) return;

          thumbnails.forEach(function (item) {
            var isSelected = item === thumbnail;
            item.classList.toggle('is-active', isSelected);
            item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
          });

          var nextSource = thumbnail.getAttribute('data-image-src');
          var nextAlt = thumbnail.getAttribute('data-image-alt') || '';
          var nextWidth = parseInt(thumbnail.getAttribute('data-image-width'), 10);
          var nextHeight = parseInt(thumbnail.getAttribute('data-image-height'), 10);

          mainImage.classList.add('is-switching');
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          if (Number.isFinite(nextWidth) && nextWidth > 0) mainImage.setAttribute('width', nextWidth);
          else mainImage.removeAttribute('width');
          if (Number.isFinite(nextHeight) && nextHeight > 0) mainImage.setAttribute('height', nextHeight);
          else mainImage.removeAttribute('height');
          mainImage.alt = nextAlt;

          if (nextSource) {
            mainImage.src = nextSource;
          }

          var panel = gallery.closest('[data-lbr-specifications-panel]');
          var finishSwap = function () {
            mainImage.classList.remove('is-switching');
            window.setTimeout(function () {
              updateSpecificationsPreviewMinimum(panel);
              measurePreviewPanel(panel);
            }, 40);
          };

          if (mainImage.complete) {
            finishSwap();
          } else {
            mainImage.addEventListener('load', finishSwap, { once: true });
          }
        });
      });
    });
  }

  function measurePreviewPanel(panel) {
    if (!panel || !panel.classList.contains('is-preview')) return;

    var clip = panel.querySelector(':scope > [data-lbr-details-clip]');
    var buttonWrap = panel.querySelector(':scope > .lbr-details-toggle-wrap');
    if (!clip || !buttonWrap) return;

    updateSpecificationsPreviewMinimum(panel);

    if (panel.classList.contains('is-expanded')) {
      panel.classList.remove('is-not-truncated');
      buttonWrap.hidden = false;
      return;
    }

    var visibleHeight = clip.clientHeight;
    if (!visibleHeight) return;

    var isTruncated = clip.scrollHeight > visibleHeight + 16;
    panel.classList.toggle('is-not-truncated', !isTruncated);
    buttonWrap.hidden = !isTruncated;
  }

  function setPreviewExpanded(panel, expanded) {
    var button = panel.querySelector(
      ':scope > .lbr-details-toggle-wrap [data-lbr-preview-toggle]'
    );
    if (!button) return;

    if (!expanded) {
      panel.classList.add('is-collapsing');
    }

    panel.classList.toggle('is-expanded', expanded);
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded
      ? button.getAttribute('data-less-label')
      : button.getAttribute('data-more-label');

    if (!expanded) {
      scrollToPreviewTop(panel);

      window.requestAnimationFrame(function () {
        panel.classList.remove('is-collapsing');
        window.setTimeout(function () {
          measurePreviewPanel(panel);
        }, 60);
      });
    }
  }

  function addPreviewToggle(panel) {
    if (!panel || !panel.classList.contains('is-preview')) return;
    if (panel.getAttribute('data-lbr-preview-ready') === 'true') return;

    var clip = panel.querySelector(':scope > [data-lbr-details-clip]');
    if (!clip) return;

    panel.setAttribute('data-lbr-preview-ready', 'true');

    var moreLabel = panel.getAttribute('data-more-label') || 'Show more';
    var lessLabel = panel.getAttribute('data-less-label') || 'Show less';

    var buttonWrap = document.createElement('div');
    buttonWrap.className = 'lbr-details-toggle-wrap';
    buttonWrap.hidden = true;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'lbr-details-toggle';
    button.setAttribute('data-lbr-preview-toggle', '');
    button.setAttribute('data-more-label', moreLabel);
    button.setAttribute('data-less-label', lessLabel);
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setPreviewExpanded(
        panel,
        !panel.classList.contains('is-expanded')
      );
    });

    buttonWrap.appendChild(button);
    panel.appendChild(buttonWrap);

    clip.querySelectorAll('img').forEach(function (image) {
      if (image.complete) return;
      image.addEventListener(
        'load',
        function () {
          window.setTimeout(function () {
            measurePreviewPanel(panel);
          }, 40);
        },
        { once: true }
      );
    });

    window.setTimeout(function () {
      measurePreviewPanel(panel);
    }, 450);
  }

  function enhancePreviewPanels(root) {
    root.querySelectorAll('[data-lbr-preview-panel]').forEach(function (panel) {
      addPreviewToggle(panel);
    });
  }

  function measurePreviewPanels(root) {
    root.querySelectorAll('[data-lbr-preview-panel]').forEach(function (panel) {
      measurePreviewPanel(panel);
    });
  }

  function rebalanceQuickDetails(root) {
    root.querySelectorAll('.lbr-quick-details-grid').forEach(function (grid) {
      balanceMobileQuickDetails(grid);
    });
  }

  function findRoots(scope) {
    var roots = [];
    var searchScope = scope && scope.querySelectorAll ? scope : document;

    if (
      scope &&
      scope.nodeType === 1 &&
      scope.matches('.lbr-product-tabs')
    ) {
      roots.push(scope);
    }

    searchScope.querySelectorAll('.lbr-product-tabs').forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });

    return roots;
  }

  function enhanceProductTabs(scope) {
    findRoots(scope).forEach(function (root) {
      if (root.getAttribute('data-lbr-tabs-ready') === 'true') return;

      root.setAttribute('data-lbr-tabs-ready', 'true');
      splitProductDescription(root);
      initialiseDimensionGalleries(root);
      enhancePreviewPanels(root);
      updateAriaExpanded(root);
      rebalanceQuickDetails(root);

      root.querySelectorAll('[data-t4s-tab-item]').forEach(function (tabButton) {
        tabButton.addEventListener('click', function () {
          window.setTimeout(function () {
            updateAriaExpanded(root);
            measurePreviewPanels(root);
            rebalanceQuickDetails(root);
          }, 360);
        });
      });

      window.addEventListener(
        'resize',
        function () {
          window.setTimeout(function () {
            measurePreviewPanels(root);
            rebalanceQuickDetails(root);
          }, 120);
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceProductTabs(document);
    });
  } else {
    enhanceProductTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceProductTabs(event.target);
  });
})();